export default __webpack_public_path__ + "static/media/42.c9e52b32.jpg";